// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iiif-error-message[data-v-1c021f0b]{color:#fff;margin:0 auto;max-width:932px;padding:2.5rem 2rem 0}.icon-info[data-v-1c021f0b]{font-size:1.25rem;line-height:1.5rem;margin-right:1rem}.icon-info[data-v-1c021f0b]:before{display:inline-block;transform:rotateX(180deg)}.provider-link[data-v-1c021f0b]{color:#fff;font-weight:600;text-transform:lowercase}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
